import Image from 'next/image'
import ProductImage from '../../../public/images/product-page.jpg'
import alerts from '@/config/alerts.json'
import Button from '@/components/Button'
import { CartItem as Item } from '@/contexts/CartReducer'
import GenderMap from '@/utils/GenderMap'
import { PersonalizeURLBuilder } from '@/utils/URLBuilder'
import { useRouter } from 'next/router'
import { useCartDispatch } from '@/contexts/CartContext'
import { toast } from 'react-hot-toast'
import CartItemDisclosure from './CartItemDisclosure'
import language_translations, { LanguageTranslations } from '@/config/language'
import { v4 as uuidv4 } from 'uuid'
import NotebookDetailsModal from '../Personalize/NotebookDetailsModal'
import React from 'react'
import { addItem, removeItem } from 'CartActions'
interface Props {
  item: Item
  index: number
}
export default function CartItem({ item, index }: Props) {
  const router = useRouter()
  const cartDispatch = useCartDispatch()
  const duplicateItem = (item: Item) => {
    const new_item = { ...item, uuid: uuidv4() }
    cartDispatch(addItem(new_item))
    toast.success(alerts.cart_item_duplicated)
  }
  const deleteCartItem = (id: string) => {
    cartDispatch(removeItem(id));
    toast.success(alerts.cart_item_removed)
  }

  //For Notebook only
  const [isOpen, setIsNotebookOpen] = React.useState(false)
  const [inputName, setInputName] = React.useState(item.replace_name)
  const [inputLanguage, setInputLanguage] = React.useState<
    keyof LanguageTranslations | undefined
  >(item.language)
  const [qty, setQty] = React.useState(item.quantity)

  return (
    <>
      <div className="lg:hidden">
        <CartItemDisclosure
          item={item}
          setIsNotebookOpen={setIsNotebookOpen}
          index={index}
        />
      </div>
      <div className="cart-item hidden lg:flex bg-white py-4 px-4 rounded-md mt-4">
        <div className="lg:basis-[15%]">
          <div className="flex items-center justify-between">
            <div className="cart-item-image basis-4/12 lg:basis-auto lg:w-[120px]">
              <Image
                src={process.env.NEXT_PUBLIC_CDN_URL + '/' + item.image}
                alt="product-image"
                width={150}
                height={150}
                className="rounded-md w-full h-[120px] object-cover"
              />
            </div>
          </div>
          {/*
           * Hidden on Desktop
           */}
          <div className="flex items-center lg:hidden">
            <button className="bg-red w-11 h-11 rounded-full hidden lg:flex items-center justify-center">
              <svg
                width="20"
                height="24"
                viewBox="0 0 20 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19 4H15.9C15.6679 2.87141 15.0538 1.85735 14.1613 1.12872C13.2687 0.40009 12.1522 0.00145452 11 0L9 0C7.8478 0.00145452 6.73132 0.40009 5.83875 1.12872C4.94618 1.85735 4.3321 2.87141 4.1 4H1C0.734784 4 0.48043 4.10536 0.292893 4.29289C0.105357 4.48043 0 4.73478 0 5C0 5.26522 0.105357 5.51957 0.292893 5.70711C0.48043 5.89464 0.734784 6 1 6H2V19C2.00159 20.3256 2.52888 21.5964 3.46622 22.5338C4.40356 23.4711 5.6744 23.9984 7 24H13C14.3256 23.9984 15.5964 23.4711 16.5338 22.5338C17.4711 21.5964 17.9984 20.3256 18 19V6H19C19.2652 6 19.5196 5.89464 19.7071 5.70711C19.8946 5.51957 20 5.26522 20 5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4V4ZM9 2H11C11.6203 2.00076 12.2251 2.19338 12.7316 2.55144C13.2381 2.90951 13.6214 3.41549 13.829 4H6.171C6.37858 3.41549 6.7619 2.90951 7.26839 2.55144C7.77487 2.19338 8.37973 2.00076 9 2V2ZM16 19C16 19.7956 15.6839 20.5587 15.1213 21.1213C14.5587 21.6839 13.7956 22 13 22H7C6.20435 22 5.44129 21.6839 4.87868 21.1213C4.31607 20.5587 4 19.7956 4 19V6H16V19Z"
                  fill="#FFFFFE"
                />
              </svg>
            </button>
            <h2 className="mt-4 text-red text-xl font-semibold">
              ₪{item.price}
            </h2>
          </div>
        </div>
        {item['product_type'] ? (
          <div className="cart-item-content w-full lg:mr-4">
            <h1 className="font-semibold text-2xl my-2 text-primary">
              {item.demo_name.replace('{basmti}', item.replace_name)}
            </h1>
            {item.product_type == 2 && (
              <div className="mt-3 lg:flex">
                <p className="text-gray-400">اسم الطفل:</p>
                <p className="text-primary lg:mr-2">{item.replace_name}</p>
              </div>
            )}

            {item.product_type == 2 && (
              <div className="mt-3 lg:flex">
                <p className="text-gray-400">نوع الدفتر:</p>
                <p className="text-primary lg:mr-2">
                  {item.language ? language_translations[item.language] : ''}
                </p>
              </div>
            )}

            {item.product_type == 2 && (
              <div className="mt-3 lg:flex">
                <p className="text-gray-400">الكمية:</p>
                <p className="text-primary lg:mr-2">
                  {/*
                   *{item.quantity ? item.quantity * 4 : 0}
                   */}
                  {item.quantity} رزم
                </p>
              </div>
            )}
            {item.product_type == 1 && (
              <div className="lg:flex">
                <p className="text-gray-400">اسم الطفل: </p>
                <p className="font-medium lg:mr-2">
                  {item.replace_name} ({GenderMap(item.gender ?? '')})
                </p>
              </div>
            )}

            {item.product_type == 1 && (
              <div className="mt-3 lg:flex">
                <p className="text-gray-400">الإهداء:</p>
                <p className="text-primary lg:mr-2">
                  {item.dedication?.substring(0, 100)}...
                </p>
              </div>
            )}

            {item.product_type == 1 && (
              <div className="mt-3 lg:flex">
                <p className="text-gray-400">نوع الغلاف:</p>
                <p className="text-primary lg:mr-2">
                  {item.cover?.name} ({item.cover?.price}₪)
                </p>
              </div>
            )}
            <div className="buttons lg:max-w-[80%] lg:flex flex-row-reverse justify-between">
              <Button
                type="button"
                bg="primary"
                onClick={() => {
                  duplicateItem(item)
                }}
                classes={['w-full', 'mt-4', 'lg:mr-4', 'text-sm', 'py-3']}>
                إنشاء نسخة جديدة
              </Button>
              <Button
                style="outline"
                type="button"
                bg="primary"
                classes={[
                  'w-full',
                  'flex',
                  'mt-4',
                  'text-sm',
                  'justify-center',
                  'lg:mr-4',
                  'items-center',
                  'py-2',
                ]}
                onClick={e => {
                  e.preventDefault()

                  if (item.product_type == 1) {
                    router.push(
                      PersonalizeURLBuilder(
                        item.inputs,
                        item.gender,
                        item.product_slug,
                        item.dedication,
                        item.cover?.id.toString(),
                        '1',
                        item.uuid,
                      ),
                    )
                  }
                  if (item.product_type == 2) {
                    setIsNotebookOpen(true)
                  }
                }}>
                <>
                  {' '}
                  <span className="ml-2">
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_1053_11105)">
                        <path
                          d="M12.9373 1.12037L4.80927 9.24837C4.49883 9.55714 4.25272 9.92441 4.08519 10.3289C3.91766 10.7335 3.83203 11.1672 3.83327 11.605V12.5004C3.83327 12.6772 3.9035 12.8468 4.02853 12.9718C4.15355 13.0968 4.32312 13.167 4.49993 13.167H5.39527C5.83311 13.1683 6.26685 13.0827 6.67137 12.9151C7.07589 12.7476 7.44317 12.5015 7.75193 12.191L15.8799 4.06304C16.2695 3.67249 16.4883 3.14336 16.4883 2.59171C16.4883 2.04006 16.2695 1.51093 15.8799 1.12037C15.4837 0.741636 14.9567 0.530273 14.4086 0.530273C13.8605 0.530273 13.3335 0.741636 12.9373 1.12037V1.12037ZM14.9373 3.12037L6.80927 11.2484C6.43335 11.622 5.92527 11.8323 5.39527 11.8337H5.1666V11.605C5.16799 11.075 5.37831 10.567 5.75193 10.191L13.8799 2.06304C14.0223 1.92701 14.2117 1.8511 14.4086 1.8511C14.6055 1.8511 14.7949 1.92701 14.9373 2.06304C15.0772 2.20338 15.1558 2.3935 15.1558 2.59171C15.1558 2.78991 15.0772 2.98003 14.9373 3.12037V3.12037Z"
                          fill="#00214D"
                        />
                        <path
                          d="M15.8333 6.486C15.6565 6.486 15.487 6.55624 15.3619 6.68126C15.2369 6.80629 15.1667 6.97586 15.1667 7.15267V10.5H12.5C11.9696 10.5 11.4609 10.7107 11.0858 11.0858C10.7107 11.4609 10.5 11.9696 10.5 12.5V15.1667H3.83333C3.3029 15.1667 2.79419 14.956 2.41912 14.5809C2.04405 14.2058 1.83333 13.6971 1.83333 13.1667V3.83333C1.83333 3.3029 2.04405 2.79419 2.41912 2.41912C2.79419 2.04405 3.3029 1.83333 3.83333 1.83333H9.86133C10.0381 1.83333 10.2077 1.7631 10.3327 1.63807C10.4578 1.51305 10.528 1.34348 10.528 1.16667C10.528 0.989856 10.4578 0.820286 10.3327 0.695262C10.2077 0.570238 10.0381 0.5 9.86133 0.5H3.83333C2.9496 0.501059 2.10237 0.852588 1.47748 1.47748C0.852588 2.10237 0.501059 2.9496 0.5 3.83333L0.5 13.1667C0.501059 14.0504 0.852588 14.8976 1.47748 15.5225C2.10237 16.1474 2.9496 16.4989 3.83333 16.5H11.3953C11.8333 16.5013 12.2671 16.4156 12.6718 16.2481C13.0764 16.0806 13.4438 15.8345 13.7527 15.524L15.5233 13.752C15.8338 13.4432 16.08 13.076 16.2477 12.6715C16.4153 12.267 16.5011 11.8332 16.5 11.3953V7.15267C16.5 6.97586 16.4298 6.80629 16.3047 6.68126C16.1797 6.55624 16.0101 6.486 15.8333 6.486ZM12.81 14.5813C12.542 14.8487 12.2031 15.0337 11.8333 15.1147V12.5C11.8333 12.3232 11.9036 12.1536 12.0286 12.0286C12.1536 11.9036 12.3232 11.8333 12.5 11.8333H15.1167C15.0342 12.2023 14.8493 12.5406 14.5833 12.8093L12.81 14.5813Z"
                          fill="#00214D"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1053_11105">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5 0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  تعديل التفاصيل{' '}
                </>
              </Button>
            </div>
          </div>
        ) : (
          <div className="cart-item-content w-full lg:mr-4">
            <h1 className="font-semibold text-2xl my-2 text-primary">
              {item.demo_name.replace('{basmti}', item.replace_name)}
            </h1>
            <div className="lg:flex">
              <p className="text-gray-400">اسم الطفل: </p>
              <p className="font-medium lg:mr-2">
                {item.replace_name} ({GenderMap(item.gender ?? '')})
              </p>
            </div>

            <div className="mt-3 lg:flex">
              <p className="text-gray-400">الإهداء:</p>
              <p className="text-primary lg:mr-2">
                {item.dedication?.substring(0, 100)}...
              </p>
            </div>

            <div className="mt-3 lg:flex">
              <p className="text-gray-400">نوع الغلاف:</p>
              <p className="text-primary lg:mr-2">
                {item.cover?.name} ({item.cover?.price}₪)
              </p>
            </div>
            <div className="buttons lg:max-w-[80%] lg:flex flex-row-reverse justify-between">
              <Button
                type="button"
                bg="primary"
                onClick={() => {
                  duplicateItem(item)
                }}
                classes={['w-full', 'mt-4', 'lg:mr-4', 'text-sm', 'py-3']}>
                إنشاء نسخة جديدة
              </Button>
              <Button
                style="outline"
                type="button"
                bg="primary"
                classes={[
                  'w-full',
                  'flex',
                  'mt-4',
                  'text-sm',
                  'justify-center',
                  'lg:mr-4',
                  'items-center',
                  'py-2',
                ]}
                onClick={e => {
                  e.preventDefault()

                  if (item.product_type == 1) {
                    router.push(
                      PersonalizeURLBuilder(
                        item.inputs,
                        item.gender,
                        item.product_slug,
                        item.dedication,
                        item.cover?.id.toString(),
                        '1',
                        item.uuid,
                      ),
                    )
                  }
                  if (item.product_type == 2) {
                    setIsNotebookOpen(true)
                  }
                }}>
                <>
                  {' '}
                  <span className="ml-2">
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_1053_11105)">
                        <path
                          d="M12.9373 1.12037L4.80927 9.24837C4.49883 9.55714 4.25272 9.92441 4.08519 10.3289C3.91766 10.7335 3.83203 11.1672 3.83327 11.605V12.5004C3.83327 12.6772 3.9035 12.8468 4.02853 12.9718C4.15355 13.0968 4.32312 13.167 4.49993 13.167H5.39527C5.83311 13.1683 6.26685 13.0827 6.67137 12.9151C7.07589 12.7476 7.44317 12.5015 7.75193 12.191L15.8799 4.06304C16.2695 3.67249 16.4883 3.14336 16.4883 2.59171C16.4883 2.04006 16.2695 1.51093 15.8799 1.12037C15.4837 0.741636 14.9567 0.530273 14.4086 0.530273C13.8605 0.530273 13.3335 0.741636 12.9373 1.12037V1.12037ZM14.9373 3.12037L6.80927 11.2484C6.43335 11.622 5.92527 11.8323 5.39527 11.8337H5.1666V11.605C5.16799 11.075 5.37831 10.567 5.75193 10.191L13.8799 2.06304C14.0223 1.92701 14.2117 1.8511 14.4086 1.8511C14.6055 1.8511 14.7949 1.92701 14.9373 2.06304C15.0772 2.20338 15.1558 2.3935 15.1558 2.59171C15.1558 2.78991 15.0772 2.98003 14.9373 3.12037V3.12037Z"
                          fill="#00214D"
                        />
                        <path
                          d="M15.8333 6.486C15.6565 6.486 15.487 6.55624 15.3619 6.68126C15.2369 6.80629 15.1667 6.97586 15.1667 7.15267V10.5H12.5C11.9696 10.5 11.4609 10.7107 11.0858 11.0858C10.7107 11.4609 10.5 11.9696 10.5 12.5V15.1667H3.83333C3.3029 15.1667 2.79419 14.956 2.41912 14.5809C2.04405 14.2058 1.83333 13.6971 1.83333 13.1667V3.83333C1.83333 3.3029 2.04405 2.79419 2.41912 2.41912C2.79419 2.04405 3.3029 1.83333 3.83333 1.83333H9.86133C10.0381 1.83333 10.2077 1.7631 10.3327 1.63807C10.4578 1.51305 10.528 1.34348 10.528 1.16667C10.528 0.989856 10.4578 0.820286 10.3327 0.695262C10.2077 0.570238 10.0381 0.5 9.86133 0.5H3.83333C2.9496 0.501059 2.10237 0.852588 1.47748 1.47748C0.852588 2.10237 0.501059 2.9496 0.5 3.83333L0.5 13.1667C0.501059 14.0504 0.852588 14.8976 1.47748 15.5225C2.10237 16.1474 2.9496 16.4989 3.83333 16.5H11.3953C11.8333 16.5013 12.2671 16.4156 12.6718 16.2481C13.0764 16.0806 13.4438 15.8345 13.7527 15.524L15.5233 13.752C15.8338 13.4432 16.08 13.076 16.2477 12.6715C16.4153 12.267 16.5011 11.8332 16.5 11.3953V7.15267C16.5 6.97586 16.4298 6.80629 16.3047 6.68126C16.1797 6.55624 16.0101 6.486 15.8333 6.486ZM12.81 14.5813C12.542 14.8487 12.2031 15.0337 11.8333 15.1147V12.5C11.8333 12.3232 11.9036 12.1536 12.0286 12.0286C12.1536 11.9036 12.3232 11.8333 12.5 11.8333H15.1167C15.0342 12.2023 14.8493 12.5406 14.5833 12.8093L12.81 14.5813Z"
                          fill="#00214D"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1053_11105">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5 0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  تعديل التفاصيل{' '}
                </>
              </Button>
            </div>
          </div>
        )}

        <div className="hidden lg:flex lg:flex-col items-end justify-between mr-auto">
          <h2 className="mt-12 text-red text-xl font-semibold">
            <div className="flex flex-col items-center justify-center">
              <p>₪{item.total}</p>
              {/*
               *<p>+</p>
               */}
              {/*
               *<p>₪{item.cover.price}</p>
               */}
            </div>
          </h2>
          <button
            className="bg-red w-11 h-11 rounded-full hidden lg:flex items-center justify-center"
            onClick={() => deleteCartItem(item.uuid)}>
            <svg
              width="20"
              height="24"
              viewBox="0 0 20 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 4H15.9C15.6679 2.87141 15.0538 1.85735 14.1613 1.12872C13.2687 0.40009 12.1522 0.00145452 11 0L9 0C7.8478 0.00145452 6.73132 0.40009 5.83875 1.12872C4.94618 1.85735 4.3321 2.87141 4.1 4H1C0.734784 4 0.48043 4.10536 0.292893 4.29289C0.105357 4.48043 0 4.73478 0 5C0 5.26522 0.105357 5.51957 0.292893 5.70711C0.48043 5.89464 0.734784 6 1 6H2V19C2.00159 20.3256 2.52888 21.5964 3.46622 22.5338C4.40356 23.4711 5.6744 23.9984 7 24H13C14.3256 23.9984 15.5964 23.4711 16.5338 22.5338C17.4711 21.5964 17.9984 20.3256 18 19V6H19C19.2652 6 19.5196 5.89464 19.7071 5.70711C19.8946 5.51957 20 5.26522 20 5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4V4ZM9 2H11C11.6203 2.00076 12.2251 2.19338 12.7316 2.55144C13.2381 2.90951 13.6214 3.41549 13.829 4H6.171C6.37858 3.41549 6.7619 2.90951 7.26839 2.55144C7.77487 2.19338 8.37973 2.00076 9 2V2ZM16 19C16 19.7956 15.6839 20.5587 15.1213 21.1213C14.5587 21.6839 13.7956 22 13 22H7C6.20435 22 5.44129 21.6839 4.87868 21.1213C4.31607 20.5587 4 19.7956 4 19V6H16V19Z"
                fill="#FFFFFE"
              />
            </svg>
          </button>
        </div>
      </div>

      {item.product_type == 2 && (
        <NotebookDetailsModal
          isOpen={isOpen}
          setIsNotebookOpen={setIsNotebookOpen}
          slug={item.product_slug}
          inputLanguage={inputLanguage}
          isEdit={true}
          setInputLanguage={setInputLanguage}
          inputName={inputName}
          qty={qty ?? 1}
          setQty={setQty}
          uuid={item.uuid}
          setInputName={setInputName}
        />
      )}
    </>
  )
}
